import type { TaskListElement } from 'shared/graphql/graphql'
import { TASK_STATES, TASK_STATES_TRANSLATIONS } from '../../constants'

export const getTaskState = ({ statusFe }: Pick<TaskListElement, 'statusFe'>) => {
  if (!statusFe || !(statusFe in TASK_STATES)) return ''

  return TASK_STATES_TRANSLATIONS[statusFe as keyof typeof TASK_STATES]
}
